export default "__VITE_ASSET__C8krjgB2__"